<template>
    <div class="alert-box alert">
        <template v-if="isTypeString()">
            {{ errors }}
        </template>
        <!-- Else: When the error is an error object given by Laravel (422) -->
        <template v-else>
            <template  v-for="error_field in errors">
                <template v-for="error in error_field">
                    {{ error }}
                </template>
            </template>
        </template>
    </div>
</template>
<script>
    export default {
        name: 'errors',
        props: ['errors'],
        methods: {
            /**
             * Check if any error exists
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            hasErrors: function() 
            {
                // If errors is not null and has a bigger length than 0, return true
                return this.errors !== null && Object.keys(this.errors).length > 0;
            },
            /**
             * Is the given error a string (A custom message)
             */
            isTypeString: function()
            {
                return typeof this.errors === 'string';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/ui/errors.vue